import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './home.component.html'
})
export class HomeComponent { 
    constructor(private router: Router) {}

  navigate(route: string): void {
    this.router.navigate([route]);
  }
}